module.exports = __webpack_public_path__ + "img/cleanup10-7-8-2021.f5a6cd51.jpg";